import { useMemo } from 'react';
import { TimeSignal, TimeSignalClassification } from 'graphql/types';

export enum GroupClassification {
  Accepted = 'ACCEPTED',
  Private = 'PRIVATE',
  Trash = 'TRASH',
  Unclassified = 'UNCLASSIFIED',
  Multiple = 'MULTIPLE'
}

interface UseGroupClassificationReturnProps {
  groupClassification: GroupClassification | undefined;
}

const timeSignalClassificationToGroupClassification = (
  classification: TimeSignalClassification
) => {
  if (classification === TimeSignalClassification.Unclassified) {
    return GroupClassification.Unclassified;
  } else if (classification === TimeSignalClassification.Private) {
    return GroupClassification.Private;
  } else if (classification === TimeSignalClassification.Accepted) {
    return GroupClassification.Accepted;
  } else {
    return GroupClassification.Trash;
  }
};

export const useGroupClassification = (
  notes: TimeSignal[]
): UseGroupClassificationReturnProps => {
  return useMemo(() => {
    if (notes.length === 0) {
      return {
        groupClassification: undefined
      };
    }

    const classification = notes[0].classification;
    const areAllNotesClassifiedIdentically = notes.every(
      (note: TimeSignal) => note.classification === classification
    );
    return {
      groupClassification: areAllNotesClassifiedIdentically
        ? timeSignalClassificationToGroupClassification(classification)
        : GroupClassification.Multiple
    };
  }, [notes]);
};
